// Iter 245 — Single source of truth for rendering live match minutes.
//
// Football matches that go into stoppage time (45+x at end of 1st half,
// 90+x at end of 2nd half) need a special display so users see WHY the
// clock isn't stopping — and how many minutes the referee added.
//
// Iter 246 — Extra Time clarity.
// When a knockout match continues past 90' into Extra Time (status "ET"),
// API-Sports keeps `elapsed` ticking past 90 (91, 92 … 120) without any
// indicator that we've left regulation.  The pill ended up reading "96'"
// or "109'" and users — reasonably — asked "is the clock broken?".  We
// now prefix the minute with "ET" once the match is in extra-time
// status AND the elapsed is past 90, so the badge reads "ET 96'" or
// "ET 109+2'" depending on stoppage.
//
// API-Sports exposes the referee-added minutes on
//   fixture.status.extra
// which the backend now passes through as `minute_extra` on every live
// payload.
//
//   formatLiveMinute(minute, minuteExtra, status) →
//     ""  (NS/TBD/PST, no minute yet)
//     "HT" / "FT" / "AET" / "PEN"
//     "12'" / "45'"                 — normal play
//     "45+2'" / "90+5'"             — referee stoppage in regulation
//     "ET 96'" / "ET 109'"          — extra time, no stoppage
//     "ET 105+2'" / "ET 120+3'"     — extra time + stoppage
//     "P 121'"                       — penalties (rare, just in case)
//
// Status codes (API-Sports):
//   NS = Not Started, 1H = 1st Half, HT = Halftime, 2H = 2nd Half,
//   ET = Extra Time, P  = Penalties, BT = Break Time, SUSP = Suspended,
//   INT = Interrupted, FT = Full Time, AET = Aet, PEN = Pen
export function formatLiveMinute(minute, minuteExtra, status) {
  if (status === "HT") return "HT";
  if (status === "FT" || status === "AET" || status === "PEN") return status;
  if (status === "NS" || status === "TBD" || status === "PST") return "";
  // Iter 247 — friendly labels for break / interrupt status codes that
  // were leaking through as raw "BT" / "INT" / "SUSP" in the live pill.
  if (status === "BT") return "Break";
  if (status === "INT") return "Interrupted";
  if (status === "SUSP") return "Suspended";

  // Build the raw "MM" or "MM+X" body first, then optionally prefix it
  // with an "ET" / "P" badge so users know we're past regulation.
  if (typeof minute !== "number") return "";
  const body = (typeof minuteExtra === "number" && minuteExtra > 0)
    ? `${minute}+${minuteExtra}'`
    : `${minute}'`;

  if (status === "ET" && minute > 90) return `ET ${body}`;
  if (status === "P" && minute > 0)   return `P ${body}`;
  return body;
}
